/**
 * GiftDetailContainer
 * --
 */
import React from 'react';
import GiftDetailPresenter from './GiftDetailPresenter';

const GiftDetailContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <GiftDetailPresenter />
    </>
  );
};

export default GiftDetailContainer;
